import React from 'react';
import TopBar from './TopBar/index';
import * as styledComponents from './styles';
import ShopItems from './ShopItems';
import Cart from './Cart';
import Detail from './Detail/index.tsx';

import {
 Route, Switch, Redirect
} from 'react-router-dom';

const Shop = () => {

  return (
    <styledComponents.ShopContainer>
      <TopBar />
      <Switch>
        <Route path='*/explore' component={ShopItems} />
        <Route path='*/detail/:serviceId' component={Detail} />
        <Route path='*/cart' component={Cart} />
        <Route path="/" render={() => (
          <Redirect to='/shop/explore' />
        )} />
      </Switch>
    </styledComponents.ShopContainer>
  );
}

export default Shop;
